'use client';

import { PropsWithChildren } from 'react';
import useExperiments from '@alltrails/experiments/hooks/useExperiments';
import useIsPage from '@/hooks/useIsPage';
import MobileViewToggle from '../MobileViewToggle/MobileViewToggle';
import TripPlannerMobileTryCta from '../TripPlanner/TripPlannerMobileTryCta';
import styles from './MobileResultsList.module.scss';

type Props = {};

const MobileResultsList = ({ children }: PropsWithChildren<Props>) => {
  const isTripPlannerV2Enabled = useExperiments()['web-disco-rm-trip-planner-v2']?.value === 'on';
  // Ideally this check doesn't exist, but doing so ends up relying on a larger refactor.
  // https://alltrails.atlassian.net/browse/XPLR-21
  const { isTripPlanner } = useIsPage();

  return (
    <div className={styles.mobileTrailList}>
      {children}
      {!isTripPlannerV2Enabled && (
        <div className={styles.floatingCtas}>
          <MobileViewToggle />
          {isTripPlanner && <TripPlannerMobileTryCta showIn="list" />}
        </div>
      )}
    </div>
  );
};

export default MobileResultsList;
